import React from 'react';
import { observer } from 'mobx-react';
import { observable, flow, reaction } from 'mobx';
import { Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-mobx-reactstrap-validation';
import { Spring, animated } from 'react-spring';

import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import Backdrop from 'js/components/core/Backdrop';
import Constraint from 'js/components/Constraint';

import analytics from 'js/services/Analytics';
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import { makeRequest, errorResponse, navigate, url } from 'js/services/Network';
import { lightGrey1Color } from 'js/config/style';

import PageTitle from './PageTitle';
import Icon from './Icon';
import Message from './Message';
import Error from './Error';
import Button from './Button';

@observer
export default class ForgotPasswordPage extends PageComponent {
  pageName = 'ForgotPasswordPage';
  pageColor = lightGrey1Color;

  pageEvent = () => { /*analytics.page('Reset Password')*/ };

  constructor(props) {
    super(props);
    AppState.hideLoginSignup();
    this.loggedInReaction = reaction(() => AppUser.isLoggedIn, isLoggedIn => isLoggedIn && navigate(url('home-page')));
  }

  componentWillUnmount() {
    this.loggedInReaction();
  }

  @observable email = '';
  @observable requestInProgress = false;
  @observable wasSuccessful = false;
  @observable error = null;

  submit = flow(function*(formValues) {
    this.error = null;

    if (!this.requestInProgress) {
      this.email = formValues.email;
      this.requestInProgress = true;

      try {
        yield makeRequest('forgot-password', null, formValues);
        // analytics.track('Password Reset Requested', {
        //   email: formValues.email,
        // });
        this.wasSuccessful = true;
      } catch (error) {
        this.error = errorResponse(error);
      }

      this.requestInProgress = false;
    }
  });

  renderPage() {
    const { requestInProgress, error } = this;
    const offset = this.wasSuccessful ? '0rem' : '3rem';

    return (
      <AppContent padded>
        <Backdrop offset={offset}>
          <Constraint>
            <PageTitle>Request password reset</PageTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset={offset}>
          {this.wasSuccessful ? (
            <Spring native reset from={{ opacity: 0 }} to={{ opacity: 1 }}>
              {animation => (
                <animated.div style={animation}>
                  <Message>
                    <Icon name="check" />
                    <div>
                      An email has now been sent to <em>{this.email || 'unknown'}</em> with a link in it that can be
                      used to change your password.
                    </div>
                  </Message>
                </animated.div>
              )}
            </Spring>
          ) : (
            <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
              {animation => (
                <animated.div style={animation}>
                  <AvForm onValidSubmit={(event, values) => this.submit(values)}>
                    <AvGroup>
                      <Label for="email">Your email address</Label>
                      <AvInput name="email" placeholder="email@address.com" required validate={{ email: true }} />
                    </AvGroup>

                    {error && <Error>{error}</Error>}

                    <Button type="submit" isLoading={requestInProgress}>
                      {requestInProgress ? 'Requesting reset ...' : 'Request password reset'}
                    </Button>
                  </AvForm>
                </animated.div>
              )}
            </Spring>
          )}
        </Constraint>
      </AppContent>
    );
  }
}
